import script from "./GoalByBank.vue?vue&type=script&setup=true&lang=js"
export * from "./GoalByBank.vue?vue&type=script&setup=true&lang=js"

import "./GoalByBank.vue?vue&type=style&index=0&id=11eb33dc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11eb33dc"]])

export default __exports__